const MODE = {
  SINGLE_CHOICE   : 'SINGLE_CHOICE',
  MULTIPLE_CHOICE : 'MULTIPLE_CHOICE'
};

export {
  MODE
};
